<div style="overflow-y: scroll;overflow-x: hidden; height: 100%; width:100%; background-color: #E7EAEB;" class="app-admin-wrap"
  [dir]='layoutConf.dir' *ngIf="true">
  <div class="rightside-content-hold">
    <!-- View Loader -->
    <div class="view-loader" *ngIf="isModuleLoading">
      <div class="spinner">
        <div class="double-bounce1 mat-bg-accent"></div>
        <div class="double-bounce2 mat-bg-primary"></div>
      </div>
    </div>

    <!-- View outlet -->
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
